export const fetchAPI = async (url, method = "GET", data = null) => {
    try {
        const response = await fetch(url, {
            method,
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "x-csrf-token": Liferay.authToken
            },
            body: data ? JSON.stringify(data) : null,
        });

        if (!response.ok) {
            throw new Error(`API Error (${response.status}): ${response.statusText}`);
        }

        // Check if response has content before parsing JSON
        const contentType = response.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
            return await response.json();
        }

        return null; // Return null for empty responses
    } catch (error) {
        console.error(`Error in API call (${method} ${url}):`, error.message);
        return null;
    }
};